<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <app-select
          @input="fetchAllItems"
          v-model="filter_employee"
          :reduce="item => item.id"
          :options="employee_options"
          label="full_name"
          placeholder="Employee"
          class="select--300"
        />
      </app-cells>
      <app-cells>
        <h2 class="title">New</h2>
      </app-cells>
      <v-client-table
        :data="table_new.items"
        :columns="table_new.columns"
        :options="table_new.options"
        class="table-default"
        :class="{ 'table-default--loading': table_new_preloader }"
      >
        <template #h__story><div class="table-default__left">Story</div></template>
        <template #h__lead><div class="table-default__left">Lead</div></template>
        <template #h__manager><div class="table-default__left">Manager</div></template>
        <template #story="{ row }">
          <app-cells :indent="false">
            <a
              :href="`https://story.altezza.travel/clients/${row.lead?.final_itinerary?.itinerary_id}`"
              target="_blank"
              class="table-default__activity table-default__activity--itinerary"
              :class="{ 'table-default__activity--active': row.lead?.final_itinerary?.itinerary_id }"
            />
            <a
              :href="`https://story.altezza.travel/itinerary/${row.lead?.final_itinerary?.hash}`"
              target="_blank"
              class="table-default__activity table-default__activity--clients"
              :class="{ 'table-default__activity--active': row.lead?.final_itinerary?.hash }"
            />
          </app-cells>
        </template>
        <template #lead="{ row }">
          <div class="table-default__left">
            <router-link
              :to=" { name: 'leads-detail-lead', params: { id: row.lead.id } }"
              class="table-default__link-border"
            >
              {{ row.lead.name }}
            </router-link>
          </div>
        </template>
        <template #status="{ row }">
          <span class="status-tag" :style="{ 'backgroundColor': row.lead.status.color }">
            {{ row.lead.status.name }}
          </span>
        </template>
        <template #amount="{ row }">{{ parseFloat(row.amount).toLocaleString() }}</template>
        <template #commission="{ row }">{{ parseFloat(row.commission).toLocaleString() }}</template>
        <template #confirmed="{ row }">{{ dateFormat(row.lead.analytic_info.confirmation_date) }}</template>
        <template #completed="{ row }">{{ dateFormat(row.lead.analytic_info.completion_date) }}</template>
        <template #manager="{ row }">
          <div class="table-default__left">
            <div class="table-default__controls">
              <div class="table-default__photo">
                <img :src="getUserAvatar(row.manager.crop.crop_url)" alt="">
              </div>
              {{ row.manager.full_name }}
            </div>
          </div>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickNewPagination"
            v-if="pagination_new.pages > 1"
            v-model="pagination_new.page"
            :page-count="pagination_new.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_new.count" :count="table_new.items.length" :page="pagination_new.page" :limit="40" />
      </app-cells>
      <template v-if="table_completed.items.length">
        <app-cells>
          <h2 class="title">Completed</h2>
        </app-cells>
        <v-client-table
          :data="table_completed.items"
          :columns="table_completed.columns"
          :options="table_completed.options"
          class="table-default"
          :class="{ 'table-default--loading': table_completed_preloader }"
        >
          <template #h__story><div class="table-default__left">Story</div></template>
          <template #h__lead><div class="table-default__left">Lead</div></template>
          <template #h__amount_difference>Amount<br>difference</template>
          <template #h__commission_difference>Commission<br>difference</template>
          <template #h__manager><div class="table-default__left">Manager</div></template>
          <template #story="{ row }">
            <app-cells :indent="false">
              <a
                :href="`https://story.altezza.travel/clients/${row.lead?.final_itinerary?.itinerary_id}`"
                target="_blank"
                class="table-default__activity table-default__activity--itinerary"
                :class="{ 'table-default__activity--active': row.lead?.final_itinerary?.itinerary_id }"
              />
              <a
                :href="`https://story.altezza.travel/itinerary/${row.lead?.final_itinerary?.hash}`"
                target="_blank"
                class="table-default__activity table-default__activity--clients"
                :class="{ 'table-default__activity--active': row.lead?.final_itinerary?.hash }"
              />
            </app-cells>
          </template>
          <template #lead="{ row }">
            <div class="table-default__left">
              <router-link
                :to=" { name: 'leads-detail-lead', params: { id: row.lead.id } }"
                class="table-default__link-border"
              >
                {{ row.lead.name }}
              </router-link>
            </div>
          </template>
          <template #status="{ row }">
          <span class="status-tag" :style="{ 'backgroundColor': row.lead.status.color }">
            {{ row.lead.status.name }}
          </span>
          </template>
          <template #amount="{ row }">{{ parseFloat(row.amount).toLocaleString() }}</template>
          <template #commission="{ row }">{{ parseFloat(row.commission).toLocaleString() }}</template>
          <template #amount_difference="{ row }">{{ parseFloat(row.amount_diff).toLocaleString() }}</template>
          <template #commission_difference="{ row }">{{ parseFloat(row.commission_diff).toLocaleString() }}</template>
          <template #completed="{ row }">{{ dateFormat(row.lead.analytic_info.completion_date) }}</template>
          <template #manager="{ row }">
            <div class="table-default__left">
              <div class="table-default__controls">
                <div class="table-default__photo">
                  <img :src="getUserAvatar(row.manager.crop.crop_url)" alt="">
                </div>
                {{ row.manager.full_name }}
              </div>
            </div>
          </template>
        </v-client-table>
        <app-cells position="between">
          <div>
            <paginate
              :clickHandler="onClickCompletedPagination"
              v-if="pagination_completed.pages > 1"
              v-model="pagination_completed.page"
              :page-count="pagination_completed.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records :all="pagination_completed.count" :count="table_completed.items.length" :page="pagination_completed.page" :limit="40" />
        </app-cells>
      </template>
      <template v-if="table_changed.items.length">
        <app-cells>
          <h2 class="title">Changed</h2>
        </app-cells>
        <v-client-table
          :data="table_changed.items"
          :columns="table_changed.columns"
          :options="table_changed.options"
          class="table-default"
          :class="{ 'table-default--loading': table_changed_preloader }"
        >
          <template #h__story><div class="table-default__left">Story</div></template>
          <template #h__lead><div class="table-default__left">Lead</div></template>
          <template #h__amount_difference>Amount<br>difference</template>
          <template #h__commission_difference>Commission<br>difference</template>
          <template #h__manager><div class="table-default__left">Manager</div></template>
          <template #story="{ row }">
            <app-cells :indent="false">
              <a
                :href="`https://story.altezza.travel/clients/${row.lead?.final_itinerary?.itinerary_id}`"
                target="_blank"
                class="table-default__activity table-default__activity--itinerary"
                :class="{ 'table-default__activity--active': row.lead?.final_itinerary?.itinerary_id }"
              />
              <a
                :href="`https://story.altezza.travel/itinerary/${row.lead?.final_itinerary?.hash}`"
                target="_blank"
                class="table-default__activity table-default__activity--clients"
                :class="{ 'table-default__activity--active': row.lead?.final_itinerary?.hash }"
              />
            </app-cells>
          </template>
          <template #lead="{ row }">
            <div class="table-default__left">
              <router-link
                :to=" { name: 'leads-detail-lead', params: { id: row.lead.id } }"
                class="table-default__link-border"
              >
                {{ row.lead.name }}
              </router-link>
            </div>
          </template>
          <template #status="{ row }">
          <span class="status-tag" :style="{ 'backgroundColor': row.lead.status.color }">
            {{ row.lead.status.name }}
          </span>
          </template>
          <template #amount="{ row }">{{ parseFloat(row.amount).toLocaleString() }}</template>
          <template #commission="{ row }">{{ parseFloat(row.commission).toLocaleString() }}</template>
          <template #amount_difference="{ row }">{{ parseFloat(row.amount_diff).toLocaleString() }}</template>
          <template #commission_difference="{ row }">{{ parseFloat(row.commission_diff).toLocaleString() }}</template>
          <template #manager="{ row }">
            <div class="table-default__left">
              <div class="table-default__controls">
                <div class="table-default__photo">
                  <img :src="getUserAvatar(row.manager.crop.crop_url)" alt="">
                </div>
                {{ row.manager.full_name }}
              </div>
            </div>
          </template>
        </v-client-table>
        <app-cells position="between">
          <div>
            <paginate
              :clickHandler="onClickChangedPagination"
              v-if="pagination_changed.pages > 1"
              v-model="pagination_changed.page"
              :page-count="pagination_changed.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records :all="pagination_changed.count" :count="table_changed.items.length" :page="pagination_changed.page" :limit="40" />
        </app-cells>
      </template>
      <template v-if="table_cancelled.items.length">
        <app-cells>
          <h2 class="title">Cancelled</h2>
        </app-cells>
        <v-client-table
          :data="table_cancelled.items"
          :columns="table_cancelled.columns"
          :options="table_cancelled.options"
          class="table-default"
          :class="{ 'table-default--loading': table_cancelled_preloader }"
        >
          <template #h__story><div class="table-default__left">Story</div></template>
          <template #h__lead><div class="table-default__left">Lead</div></template>
          <template #h__amount_difference>Amount<br>difference</template>
          <template #h__commission_difference>Commission<br>difference</template>
          <template #h__manager><div class="table-default__left">Manager</div></template>
          <template #story="{ row }">
            <app-cells :indent="false">
              <a
                :href="`https://story.altezza.travel/clients/${row.lead?.final_itinerary?.itinerary_id}`"
                target="_blank"
                class="table-default__activity table-default__activity--itinerary"
                :class="{ 'table-default__activity--active': row.lead?.final_itinerary?.itinerary_id }"
              />
              <a
                :href="`https://story.altezza.travel/itinerary/${row.lead?.final_itinerary?.hash}`"
                target="_blank"
                class="table-default__activity table-default__activity--clients"
                :class="{ 'table-default__activity--active': row.lead?.final_itinerary?.hash }"
              />
            </app-cells>
          </template>
          <template #lead="{ row }">
            <div class="table-default__left">
              <router-link
                :to=" { name: 'leads-detail-lead', params: { id: row.lead.id } }"
                class="table-default__link-border"
              >
                {{ row.lead.name }}
              </router-link>
            </div>
          </template>
          <template #status="{ row }">
          <span class="status-tag" :style="{ 'backgroundColor': row.lead.status.color }">
            {{ row.lead.status.name }}
          </span>
          </template>
          <template #amount="{ row }">{{ parseFloat(row.amount).toLocaleString() }}</template>
          <template #commission="{ row }">{{ parseFloat(row.commission).toLocaleString() }}</template>
          <template #amount_difference="{ row }">{{ parseFloat(row.amount_diff).toLocaleString() }}</template>
          <template #commission_difference="{ row }">{{ parseFloat(row.commission_diff).toLocaleString() }}</template>
          <template #cancelled="{ row }">{{ dateFormat(row.lead.analytic_info.cancellation_date) }}</template>
          <template #manager="{ row }">
            <div class="table-default__left">
              <div class="table-default__controls">
                <div class="table-default__photo">
                  <img :src="getUserAvatar(row.manager.crop.crop_url)" alt="">
                </div>
                {{ row.manager.full_name }}
              </div>
            </div>
          </template>
        </v-client-table>
        <app-cells position="between">
          <div>
            <paginate
              :clickHandler="onClickCancelledPagination"
              v-if="pagination_cancelled.pages > 1"
              v-model="pagination_cancelled.page"
              :page-count="pagination_cancelled.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records :all="pagination_cancelled.count" :count="table_cancelled.items.length" :page="pagination_cancelled.page" :limit="40" />
        </app-cells>
      </template>
      <template v-if="table_not_changed.items.length">
        <app-cells>
          <h2 class="title">Not changed</h2>
        </app-cells>
        <v-client-table
          :data="table_not_changed.items"
          :columns="table_not_changed.columns"
          :options="table_not_changed.options"
          class="table-default"
          :class="{ 'table-default--loading': table_not_changed_preloader }"
        >
          <template #h__story><div class="table-default__left">Story</div></template>
          <template #h__lead><div class="table-default__left">Lead</div></template>
          <template #h__amount_difference>Amount<br>difference</template>
          <template #h__commission_difference>Commission<br>difference</template>
          <template #h__manager><div class="table-default__left">Manager</div></template>
          <template #story="{ row }">
            <app-cells :indent="false">
              <a
                :href="`https://story.altezza.travel/clients/${row.lead?.final_itinerary?.itinerary_id}`"
                target="_blank"
                class="table-default__activity table-default__activity--itinerary"
                :class="{ 'table-default__activity--active': row.lead?.final_itinerary?.itinerary_id }"
              />
              <a
                :href="`https://story.altezza.travel/itinerary/${row.lead?.final_itinerary?.hash}`"
                target="_blank"
                class="table-default__activity table-default__activity--clients"
                :class="{ 'table-default__activity--active': row.lead?.final_itinerary?.hash }"
              />
            </app-cells>
          </template>
          <template #lead="{ row }">
            <div class="table-default__left">
              <router-link
                :to=" { name: 'leads-detail-lead', params: { id: row.lead.id } }"
                class="table-default__link-border"
              >
                {{ row.lead.name }}
              </router-link>
            </div>
          </template>
          <template #status="{ row }">
          <span class="status-tag" :style="{ 'backgroundColor': row.lead.status.color }">
            {{ row.lead.status.name }}
          </span>
          </template>
          <template #amount="{ row }">{{ parseFloat(row.amount).toLocaleString() }}</template>
          <template #commission="{ row }">{{ parseFloat(row.commission).toLocaleString() }}</template>
          <template #amount_difference="{ row }">{{ parseFloat(row.amount_diff).toLocaleString() }}</template>
          <template #commission_difference="{ row }">{{ parseFloat(row.commission_diff).toLocaleString() }}</template>
          <template #manager="{ row }">
            <div class="table-default__left">
              <div class="table-default__controls">
                <div class="table-default__photo">
                  <img :src="getUserAvatar(row.manager.crop.crop_url)" alt="">
                </div>
                {{ row.manager.full_name }}
              </div>
            </div>
          </template>
        </v-client-table>
        <app-cells position="between">
          <div>
            <paginate
              :clickHandler="onClickNotChangedPagination"
              v-if="pagination_not_changed.pages > 1"
              v-model="pagination_not_changed.page"
              :page-count="pagination_not_changed.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records :all="pagination_not_changed.count" :count="table_not_changed.items.length" :page="pagination_not_changed.page" :limit="40" />
        </app-cells>
      </template>
    </template>
  </div>
</template>

<script>
import { getEmployeesListSearch, getLeadChangeLogs } from '@/http'
import { format, parseISO } from 'date-fns'

export default {
  name: 'AllowanceLog',
  data() {
    return {
      is_loaded: false,
      table_new_preloader: false,
      table_new: {
        items: [],
        columns: ['story', 'lead', 'status', 'amount', 'commission', 'confirmed', 'completed', 'manager'],
        options: {
          headings: {
            story: 'Story',
            lead: 'Lead',
            status: 'Status',
            amount: 'Amount',
            confirmed: 'Confirmed',
            completed: 'Completed',
            commission: 'Commission',
            manager: 'Manager'
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_new: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_completed_preloader: false,
      table_completed: {
        items: [],
        columns: ['story', 'lead', 'status', 'amount', 'commission', 'amount_difference', 'commission_difference', 'completed', 'manager'],
        options: {
          headings: {
            story: 'Story',
            lead: 'Lead',
            status: 'Status',
            amount: 'Amount',
            commission: 'Commission',
            amount_difference: 'Amount difference',
            commission_difference: 'Commission difference',
            completed: 'Completed',
            manager: 'Manager'
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_completed: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_changed_preloader: false,
      table_changed: {
        items: [],
        columns: ['story', 'lead', 'status', 'amount', 'commission', 'amount_difference', 'commission_difference', 'manager'],
        options: {
          headings: {
            story: 'Story',
            lead: 'Lead',
            status: 'Status',
            amount: 'Amount',
            commission: 'Commission',
            amount_difference: 'Amount difference',
            commission_difference: 'Commission difference',
            manager: 'Manager'
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_changed: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_cancelled_preloader: false,
      table_cancelled: {
        items: [],
        columns: ['story', 'lead', 'status', 'amount', 'commission', 'amount_difference', 'commission_difference', 'cancelled', 'manager'],
        options: {
          headings: {
            story: 'Story',
            lead: 'Lead',
            status: 'Status',
            amount: 'Amount',
            commission: 'Commission',
            amount_difference: 'Amount difference',
            commission_difference: 'Commission difference',
            cancelled: 'Cancelled',
            manager: 'Manager'
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_cancelled: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_not_changed_preloader: false,
      table_not_changed: {
        items: [],
        columns: ['story', 'lead', 'status', 'amount', 'commission', 'amount_difference', 'commission_difference', 'manager'],
        options: {
          headings: {
            story: 'Story',
            lead: 'Lead',
            status: 'Status',
            amount: 'Amount',
            commission: 'Commission',
            amount_difference: 'Amount difference',
            commission_difference: 'Commission difference',
            manager: 'Manager'
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_not_changed: {
        pages: 1,
        page: 1,
        count: 1,
      },
      employee_options: [],
      filter_employee: null,
    }
  },
  created() {
    this.fetchAllItems()
    getEmployeesListSearch({ position: 'sales_manager' })
      .then(res => { this.employee_options = res.data })
  },
  methods: {
    fetchAllItems() {
      Promise.all([
        getLeadChangeLogs({
          page: this.pagination_new.page,
          page_size: 40,
          allowance: this.$route.params.id,
          employee: this.filter_employee,
          status: 'created'
        }),
        getLeadChangeLogs({
          page: this.pagination_completed.page,
          page_size: 40,
          allowance: this.$route.params.id,
          employee: this.filter_employee,
          status: 'completed'
        }),
        getLeadChangeLogs({
          page: this.pagination_changed.page,
          page_size: 40,
          allowance: this.$route.params.id,
          employee: this.filter_employee,
          status: 'changed'
        }),
        getLeadChangeLogs({
          page: this.pagination_cancelled.page,
          page_size: 40,
          allowance: this.$route.params.id,
          employee: this.filter_employee,
          status: 'cancelled'
        }),
        getLeadChangeLogs({
          page: this.pagination_not_changed.page,
          page_size: 40,
          allowance: this.$route.params.id,
          employee: this.filter_employee,
          status: 'not_changed'
        })
      ])
        .then(res => {
          this.table_new.items = res[0].data.results
          this.pagination_new.pages = res[0].data.pages
          this.pagination_new.count = res[0].data.count
          this.table_new_preloader = false

          this.table_completed.items = res[1].data.results
          this.pagination_completed.pages = res[1].data.pages
          this.pagination_completed.count = res[1].data.count
          this.table_completed_preloader = false

          this.table_changed.items = res[2].data.results
          this.pagination_changed.pages = res[2].data.pages
          this.pagination_changed.count = res[2].data.count
          this.table_changed_preloader = false

          this.table_cancelled.items = res[3].data.results
          this.pagination_cancelled.pages = res[3].data.pages
          this.pagination_cancelled.count = res[3].data.count
          this.table_cancelled_preloader = false

          this.table_not_changed.items = res[4].data.results
          this.pagination_not_changed.pages = res[4].data.pages
          this.pagination_not_changed.count = res[4].data.count
          this.table_not_changed_preloader = false

          this.is_loaded = true
        })
    },
    fetchNewItems() {
      this.table_new_preloader = true
      getLeadChangeLogs({
        page: this.pagination_new.page,
        page_size: 40,
        allowance: this.$route.params.id,
        employee: this.filter_employee,
        status: 'created'
      })
        .then(res => {
          this.table_new.items = res.data.results
          this.pagination_new.pages = res.data.pages
          this.pagination_new.count = res.data.count
          this.table_new_preloader = false
        })
    },
    fetchCompletedItems() {
      this.table_completed_preloader = true
      getLeadChangeLogs({
        page: this.pagination_completed.page,
        page_size: 40,
        allowance: this.$route.params.id,
        employee: this.filter_employee,
        status: 'completed'
      })
        .then(res => {
          this.table_completed.items = res.data.results
          this.pagination_completed.pages = res.data.pages
          this.pagination_completed.count = res.data.count
          this.table_completed_preloader = false
        })
    },
    fetchChangedItems() {
      this.table_changed_preloader = true
      getLeadChangeLogs({
        page: this.pagination_changed.page,
        page_size: 40,
        allowance: this.$route.params.id,
        employee: this.filter_employee,
        status: 'changed'
      })
        .then(res => {
          this.table_changed.items = res.data.results
          this.pagination_changed.pages = res.data.pages
          this.pagination_changed.count = res.data.count
          this.table_changed_preloader = false
        })
    },
    fetchCancelledItems() {
      this.table_cancelled_preloader = true
      getLeadChangeLogs({
        page: this.pagination_cancelled.page,
        page_size: 40,
        allowance: this.$route.params.id,
        employee: this.filter_employee,
        status: 'cancelled'
      })
        .then(res => {
          this.table_cancelled.items = res.data.results
          this.pagination_cancelled.pages = res.data.pages
          this.pagination_cancelled.count = res.data.count
          this.table_cancelled_preloader = false
        })
    },
    fetchNotChangedItems() {
      this.table_cancelled_preloader = true
      getLeadChangeLogs({
        page: this.pagination_not_changed.page,
        page_size: 40,
        allowance: this.$route.params.id,
        employee: this.filter_employee,
        status: 'not_changed'
      })
        .then(res => {
          this.table_not_changed.items = res.data.results
          this.pagination_not_changed.pages = res.data.pages
          this.pagination_not_changed.count = res.data.count
          this.table_not_changed_preloader = false
        })
    },
    onClickNewPagination(page) {
      this.pagination_new.page = page
      this.fetchNewItems()
    },
    onClickCompletedPagination(page) {
      this.pagination_completed.page = page
      this.fetchCompletedItems()
    },
    onClickChangedPagination(page) {
      this.pagination_changed.page = page
      this.fetchChangedItems()
    },
    onClickCancelledPagination(page) {
      this.pagination_cancelled.page = page
      this.fetchCancelledItems()
    },
    onClickNotChangedPagination(page) {
      this.pagination_not_changed.page = page
      this.fetchNotChangedItems()
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
    dateFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy') : '-'
    },
  }
}
</script>
